<iframe width="100%" height="100%" allowscriptaccess="always" [src]="sanitizer.bypassSecurityTrustResourceUrl(iframeSrc())"></iframe>
